import type { ShouldRevalidateFunction } from "react-router-dom";

export const FINANCE_PAGE_TABS = ["operations", "analytics"] as const;
export type FinancePageTab = (typeof FINANCE_PAGE_TABS)[number];

export function parseFinancePageTabFromSearch(search: string): FinancePageTab {
  return parseFinancePageTab(new URLSearchParams(search).get("tab"));
}

/** Tab switches only change `?tab=`; finance loader data does not depend on tab. */
export function onlyFinanceTabQueryChanged(current: URL, next: URL): boolean {
  if (current.pathname !== next.pathname) return false;
  if (current.search === next.search) return false;

  const currentParams = new URLSearchParams(current.search);
  const nextParams = new URLSearchParams(next.search);
  const keys = new Set<string>();
  currentParams.forEach((_, key) => keys.add(key));
  nextParams.forEach((_, key) => keys.add(key));

  for (const key of Array.from(keys)) {
    if (key === "tab") continue;
    if ((currentParams.get(key) ?? "") !== (nextParams.get(key) ?? "")) {
      return false;
    }
  }

  return (currentParams.get("tab") ?? "") !== (nextParams.get("tab") ?? "");
}

export const financePageShouldRevalidate: ShouldRevalidateFunction = ({
  currentUrl,
  nextUrl,
  defaultShouldRevalidate,
}) => {
  if (onlyFinanceTabQueryChanged(currentUrl, nextUrl)) {
    return false;
  }
  return defaultShouldRevalidate;
};

export function parseFinancePageTab(value: string | null): FinancePageTab {
  if (value === "analytics" || value === "reports") {
    return "analytics";
  }
  if (
    value === "operations" ||
    value === "priority" ||
    value === "overview" ||
    value === "leases"
  ) {
    return "operations";
  }
  return "operations";
}
